/*
 * mocks/api/numbers.ts
 * Anvilo, Inc.
 *
 * This file contains numbers API mocks
 *
 * Created by Artem Yefimenko on 10/08/2020
 * Copyright (c) 2020 Anvilo, Inc. All right reserved.
 */

import { mock } from "../axios";

const API_URL = "https://testing-webapp-api.talkroute.com/api/";

const GET_NUMBERS_URL = "v1/talkroute-numbers";
const GET_BLOCKED_NUMBERS_URL = "v1/account/blocked-numbers";
const BLOCK_NUMBER_URL = "v1/account/blocked-numbers";

export const mockedNumbers = [
  {
    id: new Date().getTime(),
    number: "13317173121",
    text_messaging_allowed: true,
    text_messaging_enabled: true,
    text_messaging_status: "messaging_active",
    voice_enabled: true,
  },
  {
    id: new Date().getTime(),
    number: "17088660301",
    text_messaging_allowed: true,
    text_messaging_enabled: true,
    text_messaging_status: "messaging_active",
    voice_enabled: true,
  },
];

export const mockBlockedNumbers = [
  {
    created_at: "2020-03-18T19:33:50+0000",
    enabled: false,
    id: "652f3e9a-694f-11ea-9bdf-56000258b29a",
    number: "16504519942",
    updated_at: "2020-07-09T15:13:03+0000",
  },
];

mock.onGet(`${API_URL}${GET_NUMBERS_URL}`).reply((request) => {
  return [
    200,
    {
      data: mockedNumbers,
    },
  ];
});

mock.onGet(`${API_URL}${GET_BLOCKED_NUMBERS_URL}`).reply((request) => {
  return [
    200,
    {
      data: mockBlockedNumbers,
    },
  ];
});

mock.onPost(`${API_URL}${BLOCK_NUMBER_URL}`).reply((request) => {
  mockBlockedNumbers[0].enabled = true;
  return [
    200,
    {
      enabled: true,
    },
  ];
});

mock.onDelete(`${API_URL}${BLOCK_NUMBER_URL}`).reply((request) => {
  mockBlockedNumbers[0].enabled = false;
  return [
    200,
    {
      enabled: false,
    },
  ];
});
